import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Clipboard } from '@angular/cdk/clipboard';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { ResultsConversationalService } from 'src/app/services/learner/results-conversational.service';
import { IUserTranscriptResponse } from 'src/app/interfaces/iuser-transcript-response';
import { TranslocoService } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-results-transcript',
  templateUrl: './results-transcript.component.html',
  styleUrls: ['./results-transcript.component.scss'],
  standalone: false
})
export class ResultsTranscriptComponent {
  @Input() practiceCallUuid: string = '';
  @Input() transcriptTab: boolean = false;
  @Input() agentName: string = 'Quantified';
  @Input() userName: string = 'User';
  @Input() practiceType: string | undefined = 'PRACTICE';
  @Input() callType: string | undefined = 'CONVERSATIONAL';
  @Input() showFooter: boolean = true;
  @ViewChild(MatMenuTrigger) tooltipMenu!: MatMenuTrigger;

  transcript: string = '';
  isLoadingTranscript: boolean = false;
  isErrorLoadingScreen: boolean = false;
  displayButtonLoadingScreen: boolean = false;
  titleLoadingScreen: string = this.translocoService.translate(
    'PROCESSING_TRANSCRIPT',
    {},
    'results'
  );
  messageLoadingScreen: string = `${this.translocoService.translate(
    'WAIT_OR_REVIEW_SCORES',
    {},
    'results'
  )} <br> ${this.translocoService.translate(
    'TRANSCRIPT_LOADING',
    {},
    'results'
  )}`;
  translationLoaded: boolean = false;

  constructor(
    private clipboard: Clipboard,
    private amplitudeService: AmplitudeService,
    private resultsConversationalService: ResultsConversationalService,
    private translocoService: TranslocoService,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.translationService.loadScopedTranslation('results').then(() => {
      this.titleLoadingScreen = this.translocoService.translate(
      'PROCESSING_TRANSCRIPT',
      {},
      'results'
      );
      this.messageLoadingScreen = `${this.translocoService.translate(
      'WAIT_OR_REVIEW_SCORES',
      {},
      'results'
      )} <br> ${this.translocoService.translate(
      'TRANSCRIPT_LOADING',
      {},
      'results'
      )}`;
      this.translationLoaded = true;
    });
    this.amplitudeService.trackEvent(
      AmplitudeTrackingEvents.TRANSCRIPT_PAGE_VIEW,
      {
        call_type: this.callType,
        assignment_type: this.practiceType,
      }
    );

    this.fetchTranscript();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['practiceCallUuid'] &&
      !changes['practiceCallUuid'].firstChange
    ) {
      this.transcript = '';
      this.fetchTranscript();
    }
  }

  fetchTranscript() {
    this.isLoadingTranscript = true;
    if (this.transcriptTab) {
      this.getResultsConversationalTranscript();
    }
  }

  get transformedTranscript(): string {
    let isFirstAgentSays = true;

    return this.transcript.replace(/(agentSays:|userSays:)/g, (match) => {
      if (match === 'agentSays:' && isFirstAgentSays) {
        isFirstAgentSays = false;
        return `<strong>${this.agentName}:</strong>`;
      } else if (match === 'agentSays:') {
        return `<br><br><strong>${this.agentName}:</strong>`;
      } else if (match === 'userSays:') {
        return `<br><br><strong>${this.userName}:</strong>`;
      }
      return match;
    });
  }

  copyText() {
    this.clipboard.copy(this.practiceCallUuid);
    this.tooltipMenu.openMenu();

    setTimeout(() => {
      this.tooltipMenu.closeMenu();
    }, 3000);
  }

  getResultsConversationalTranscript() {
    this.resultsConversationalService
      .getResultsConversationalTranscript(this.practiceCallUuid)
      .subscribe({
        next: (response: IUserTranscriptResponse) => {
          console.log('Transcript fetched:', response);
          if (response) {
            this.transcript = response.userTranscript;
            this.userName = response.userName;
            this.agentName = response.agentName;
          } else {
            this.transcript = '';
          }
        },
        error: (error) => {
          console.error('Error fetching transcript:', error);
        },
      });
    this.isLoadingTranscript = false;
  }
}
